import { Color } from '@kite-js/theme-types';

const maroon: Color = {
    50: '#F3ECF0',
    100: '#FCDFCF',
    200: '#F38141',
    300: '#7E1E55',
    400: '#C04500',
    500: '#772B00',
};

export default maroon;
